import {
  PurchaseFormData,
  PurchaseFormState,
} from '../slices/client-data.slice';

export const selectPurchaseForm = (state: {
  clientData: PurchaseFormState;
}) => state.clientData;

export const selectPurchaseFormData = (state: {
  clientData: PurchaseFormState;
}) => state.clientData.data;

export const selectPurchaseFormField =
  <K extends keyof PurchaseFormData>(key: K) =>
  (state: { clientData: PurchaseFormState }): PurchaseFormData[K] =>
    state.clientData.data[key];
